import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function PainPointsSection() {
  const painPoints = ['🕒 Pasan los días y sentís que apenas compartís momentos reales con tus hijos.', '📱 Todo se vuelve pantallas, trabajo y cansancio… y las charlas se hacen cada vez más cortas.', '💤 Aunque amás a tu familia, muchas noches terminás con la sensación de que no estás aprovechando el tiempo juntos.', '⚠️ Si no cambiás algo ahora, los días seguirán pasando sin esos recuerdos que tanto soñás crear.'];
  return <section className="cv-auto py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-navy-950 relative overflow-hidden" data-id="element-160">
      <div className="absolute -left-40 top-20 w-96 h-96 bg-red-500/5 rounded-full blur-[80px] pointer-events-none hidden md:block" data-id="element-161" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.4
      }} className="text-center mb-12" data-id="element-163">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white" data-id="element-164">
            💔 Mientras tratás de conectar con tu familia…{' '}
            <span className="text-red-400" data-id="element-165">el tiempo se te escapa</span>
          </h2>
        </motion.div>

        <div className="bg-navy-900 border border-navy-800 rounded-3xl p-5 md:p-10 shadow-2xl relative overflow-hidden" data-id="element-166">
          <div className="absolute top-0 left-0 w-2 h-full bg-gradient-to-b from-red-500 to-purple-500" data-id="element-167" />

          <ul className="space-y-6" data-id="element-168">
            {painPoints.map((point, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -15
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-30px'
          }} transition={{
            delay: index * 0.04,
            duration: 0.3
          }} className="flex items-start gap-4" data-id="element-169">
                <div className="bg-navy-800 p-2 rounded-lg flex-shrink-0 mt-0.5" data-id="element-170">
                  <AlertTriangle className="w-6 h-6 text-red-400" data-id="element-171" />
                </div>
                <span className="text-slate-200 text-base md:text-lg" data-id="element-172">
                  {point}
                </span>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}